import PDF from './pdf'
import { formatAccounting, capitalizeFirstLetter, getCurrentDateEnUsFormat } from '../lib/utils'

export default class SaleSummary extends PDF {
  /**
   * Description
   * @param {import('jspdf').DocumentProperties} args
   */
  constructor(args = {}) {
    super()
    this.doc.setProperties({
      unit: 'mm',
      format: 'a4',
      ...args,
    })
    this.addFonts()
  }

  /**
   * Description
   * @param {boolean} [cancel]
   */
  __header({ storeName = '', dateRange = '' }) {
    const title = `${capitalizeFirstLetter(storeName)} Sales Report`
    this.centerText({ fontSize: 24, text: title, yOffset: 15, color: [55, 71, 79] })
    this.centerText({ fontSize: 12, text: dateRange, yOffset: 22 })
    this.doc.setFillColor('#CFD8DC')
    this.doc.line(15, 25, 195, 25, 'F')
    this.brandTypeCounter = 0
  }

  /**
   * Description
   * @param {HeadingData} subHeader
   * @returns {void}
   */
  __subHeader(subHeader) {
    const { grossProfit = '', totalCost = '', grossRevenue = '', grossProfitMargin = '', brandTypeAmounts = {} } = subHeader || {}
    const [x, y] = [15, 40]
    const delimiter = ':'
    const longestWord = ['Gross Revenue'].concat(brandTypeAmounts.map((brandTypeAmount) => brandTypeAmount?.name))
      .sort((a, b) => b.length - a.length)[0] || ''
    const textLength = this.getTextWidth(longestWord + ': ', 12)


    let counter = 0
    brandTypeAmounts.forEach((brandTypeAmount) => {
      this.generateField({
        label: brandTypeAmount?.name,
        value: brandTypeAmount?.amount,
        coordinates: [x, y + (5 * counter)],
        textLength,
        delimiter,
      })
      counter++
    })

    this.generateField({
      label: 'Gross Revenue',
      value: grossRevenue,
      coordinates: [x, y + (5 * counter++)],
      textLength,
      delimiter,
    })

    this.generateField({
      label: 'Total Cost',
      value: totalCost,
      coordinates: [x, y + (5 * counter++)],
      textLength,
      delimiter,
    })

    this.brandTypeCounter = counter

    // this.generateField({
    //   label: 'Gross Profit',
    //   value: `${grossProfit} (${grossProfitMargin})`,
    //   coordinates: [x, y + (5 * counter)],
    //   textLength,
    //   delimiter,
    // })
  }

  /**
   * Description
   * @param {{ totalAmount: number; }} params
   * @param {ReceiptItem} body
   * @returns {any}
   */
  __table(_, body) {
    this.doc.autoTable({
      head: [['Item', 'Unit#', 'SRP', 'Cost', 'Total', 'Disc']],
      startY: 40 + (5 * this.brandTypeCounter),
      body: [
        ...body,
      ],
    })
  }

  /**
   * Description
   * @param {string} receiptNo
   * @returns {void}
   */
  __save(storeName) {
    const name = `${storeName}_summary_sales_${new Date().getTime()}`
    this.doc.save(name)
  }

  /**
   * Description
   * @param {HeadingData} data
   * @param {ReceiptItem[]} items
   * @returns {any}
   */
  generate(data, items) {
    this.__header(data)
    this.__subHeader(data)
    this.__table(data, items)
    this.__save(data.storeName)
  }
}

/**
 * @typedef {{[key: string]: number}} brandTypeAmount
 * 
 * @typedef HeadingData
 * @property {number} storeName
 * @property {string} dateRange
 * @property {string} grossRevenue
 * @property {number} totalCost
 * @property {string} grossProfit
 * @property {brandTypeAmount} brandTypeAmounts
 * @property {string} grossProfitMargin
 * 
 * @typedef Items
 * @property {string} item
 * @property {number} unitsSold
 * @property {string} revenue
 * @property {string} cost
 * @property {string} profitMargin
 * @property {string} profit
 * @property {string} discountRate
 */
